/**
 * 基于种子的伪随机数生成器
 * 确保相同种子产生相同的拼图形状
 */
export class Random {
    constructor(seed = 1) {
        this.initialSeed = seed;
        this.seed = seed;
    }

    /**
     * 重置为初始种子
     */
    reset() {
        this.seed = this.initialSeed;
    }

    /**
     * 设置新种子
     * @param {number} seed 新种子值
     */
    setSeed(seed) {
        this.initialSeed = seed;
        this.seed = seed;
    }

    /**
     * 生成0-1之间的随机数
     * @returns {number} 0-1之间的随机数
     */
    next() {
        const x = Math.sin(this.seed) * 10000;
        this.seed += 1;
        return x - Math.floor(x);
    }

    /**
     * 生成指定范围内的随机数
     * @param {number} min 最小值
     * @param {number} max 最大值
     * @returns {number} 范围内的随机数
     */
    range(min, max) {
        return min + this.next() * (max - min);
    }

    /**
     * 生成指定范围内的整数
     * @param {number} min 最小值（包含）
     * @param {number} max 最大值（包含）
     * @returns {number} 范围内的整数
     */
    int(min, max) {
        return Math.floor(this.range(min, max + 1));
    }

    /**
     * 生成随机布尔值
     * @param {number} probability true的概率，默认0.5
     * @returns {boolean} 随机布尔值
     */
    bool(probability = 0.5) {
        return this.next() < probability;
    }

    /**
     * 从数组中随机选择一个元素
     * @param {Array} array 源数组
     * @returns {*} 随机选中的元素
     */
    pick(array) {
        if (!array || array.length === 0) return null;
        return array[this.int(0, array.length - 1)];
    }

    /**
     * 打乱数组顺序（Fisher-Yates算法）
     * @param {Array} array 要打乱的数组
     * @returns {Array} 打乱后的新数组
     */
    shuffle(array) {
        const result = [...array];
        for (let i = result.length - 1; i > 0; i--) {
            const j = this.int(0, i);
            [result[i], result[j]] = [result[j], result[i]];
        }
        return result;
    }

    /**
     * 生成高斯分布随机数（Box-Muller变换）
     * @param {number} mean 均值
     * @param {number} stdDev 标准差
     * @returns {number} 高斯分布随机数
     */
    gaussian(mean = 0, stdDev = 1) {
        const u1 = this.next();
        const u2 = this.next();
        const z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);
        return mean + z * stdDev;
    }
}

// 默认全局实例
export const globalRandom = new Random();

export default Random;
